























































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

import { Event } from '@/models/event';
import { UiManagerService } from '@/services/UiManager';

import EventInfoSiteTemplate from './EventInfoSiteTemplate.vue';
import ImageSelect from './ImageSelect.vue';
import toast from './toast';
import { ToastType } from './toast/tost-type.enum';

@Component({
  components: {
    EventInfoSiteTemplate,
    ImageSelect,
  },
})
export default class StepEmailComponent extends Vue {
  @Prop({ required: true })
  private event!: Event & { emailTemplate?: any };

  private newEmailImage = '';

  created() {
    this.event.emailTemplate = this.event.emailTemplate || {
      template: '',
      description: this.event.info.description,
      blocks: [],
    };
  }

  selectTemplate(template: 'classic' | 'gallery') {
    this.event.emailTemplate.template = template;
    if (template === 'classic') {
      this.event.emailTemplate.blocks = this.event.emailTemplate.blocks.filter((block: any) => !block.img);
    }
    UiManagerService.scrollTo('#email-template-selected');
  }

  onAddEmailImage({ imageBase64 }: { imageBase64: string }) {
    try {
      this.newEmailImage = null;
      this.event.emailTemplate.blocks = (this.event.emailTemplate.blocks || []).concat({ img: imageBase64 });
      this.newEmailImage = '';
      toast('Imagem carregada', ToastType.SUCESS);
    } catch (err) {
      toast('Erro ao carregar imagem', ToastType.ERROR);
    }
  }

  @Emit()
  onUpdate(event: Event) {
    return event;
  }
}
